import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { ScrollText, Eye } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useDocumentPreview } from '../components/DocumentPreviewModal';
import { CharteTexte } from '../components/charte-formateur/CharteTexte';
import { StatutCharte } from '../components/charte-formateur/StatutCharte';
import { SignerCharte } from '../components/charte-formateur/SignerCharte';

export default function MaCharteFormateur() {
  const [etat, setEtat] = useState(null);
  const { previewDocument, DocumentModal } = useDocumentPreview();
  const charger = useCallback(() => {
    axios.get('/charte-formateurs/moi').then(({ data }) => setEtat(data)).catch(() => setEtat({ erreur: true }));
  }, []);
  useEffect(() => { charger(); }, [charger]);

  if (!etat) return <div className="p-8 text-slate-500" data-testid="ma-charte-chargement">Chargement…</div>;
  if (etat.erreur) return <div className="p-8 text-red-600" data-testid="ma-charte-erreur">Impossible de charger la charte.</div>;

  return (
    <div className="mx-auto max-w-4xl space-y-8" data-testid="ma-charte-page">
      <header className="rounded-2xl bg-[#0F172A] p-6 sm:p-10 text-white shadow-sm">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-xl bg-[#8DC63F]/20 p-3"><ScrollText className="h-7 w-7 text-[#8DC63F]" /></div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Ma charte</h1>
              <p className="text-sm text-white/70">Charte des formateurs FISL</p>
            </div>
          </div>
          <Button variant="secondary" className="rounded-full" data-testid="ma-charte-voir-pdf"
            onClick={() => previewDocument(null, 'Charte des formateurs FISL', `/charte-formateurs/pdf/${etat.formateur_id}`)}>
            <Eye className="mr-2 h-4 w-4" /> Voir le PDF
          </Button>
        </div>
        <StatutCharte charte={etat.charte} />
      </header>
      <CharteTexte />
      {!etat.signee && <SignerCharte signatureProfil={etat.signature_profil} onSignee={charger} />}
      <DocumentModal />
    </div>
  );
}
